import { setCookieConsentCompleted } from './analytics';

// Hide the content of cookie consent banner
const hideCookieBannerContent = () => {
  const cookieBanner = document.querySelector('.cookie-consent-banner');
  const demoButton = document.querySelector('.demo-button-until-banner');
  
  // Removing the 'd-flex' class so that we can hide the banner
  if (cookieBanner) {
    cookieBanner.classList.remove('d-flex');
    cookieBanner.style.display = 'none';
  }
  
  if (demoButton) {
    demoButton.style.display = 'none';
  }
};

// Set the value of 'cookieConsent' key in local storage
const setCookieConsentToLocalStorage = () => {
  localStorage.setItem('cookieConsent', 'true');
  hideCookieBannerContent();
  setCookieConsentCompleted(true);
};

// Set the value of 'cookieConsent' key in localstorage after 15secs and hide the cookier banner
const applyTimerHideCookieBanner = () => {
  setTimeout(() => {
    if (!localStorage.getItem('cookieConsent')) {
      setCookieConsentToLocalStorage();
    }
  }, 10000);
  
  const cookieBanner = document.querySelector('.cookie-consent-banner');
  const demoButton = document.querySelector('.demo-button-until-banner');
  
  if (cookieBanner) {
    cookieBanner.style.display = 'block';
  }
  if (demoButton) {
    demoButton.style.display = 'block';
  }
};

const hideCookieConsentBanner = () => {
  // Hide the banner for those users who have already accepted the cookie-consent and show for those who have not accepted,
  //Show the demo button in the hero section for mobile-view, since the banner overshadows the sticky demo button,
  //Hide banner after 15secs.
  if (localStorage.getItem('cookieConsent')) {
    setCookieConsentCompleted(true);
    hideCookieBannerContent();
  } else {
    applyTimerHideCookieBanner();
  }

  const bannerClose = document.querySelector('.banner-close');
  if (bannerClose) {
    bannerClose.addEventListener('click', () => {
      //Clearing timeout when close button is clicked.
      clearTimeout(applyTimerHideCookieBanner);
      setCookieConsentToLocalStorage();
    });
  }
};

// first time you visit any page in the site, we will save all params
const saveSearchString = () => {
  let searchString = localStorage.getItem('search');
  if (searchString) {
    return;
  }
  searchString = window.location.search;
  if (searchString) {
    searchString = searchString.replace('?', '');
  }
  if (!searchString) {
    searchString = '';
  }
  localStorage.setItem('search', searchString);
};

export {
  hideCookieConsentBanner,
  setCookieConsentToLocalStorage,
  saveSearchString,
};